/**
 * 预订人信息
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import { renderContent } from '@/utils';
import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/directRenewal';
import { formatAreaMobileStr } from '@/components/BaseMobileInput/helper';
import { parseFen2Currency } from '@/utils/number';

import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { customerInfo } = state;
  return { customerInfo };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { customerInfo } = props;
  return (
    <ContentBlock
      title={intl.get('reservation_booker_block_title')}
      className={styles.customerInfoBlock}
    >
      <FormItem label={intl.get('app_constants_booker_name')} className="oversize-text-item">
        {customerInfo.name}
      </FormItem>
      <FormItem label={intl.get('drawer_extension_mobile_number_label')}>
        {renderContent(customerInfo.mobile, formatAreaMobileStr)}
      </FormItem>
      <FormItem label={intl.get('reservation_booker_field_ota_virtual_label')}>
        {renderContent(customerInfo.otaOrderNo)}
      </FormItem>
      <FormItem label={intl.get('help_store_address_type_email')}>
        {renderContent(customerInfo.email)}
      </FormItem>
      <FormItem label={intl.get('drawer_extension_picker_balance_label')}>
        {renderContent(customerInfo.balance, parseFen2Currency)}
      </FormItem>
    </ContentBlock>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
